export const svgIconHostLvbetpl: string = 'https://lvbet.pl';
